import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const NoDataFound = ({ intl }) => (
  <div className="not-found-page">
    <h2>{intl.formatMessage(messages.errorMessage)}</h2>
  </div>
)

const enhance = compose(
  connect(() => ({ }), { }),
  injectIntl,
)

export default enhance(NoDataFound)

const messages = defineMessages({
  errorMessage: {
    id: 'noDataFound.errorMessage',
    defaultMessage: 'Dáta neboli nájdené.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/NoDataFound.js